export function Textarea(props) {
    return (
      <textarea
        className="border border-gray-300 px-3 py-2 rounded w-full"
        rows={4}
        {...props}
      />
    );
  }
  